export default {
  end_at: 'indtil d. {endDate}',
  today: 'I dag',
  day: 'Dag',
  month: 'Måned',
  week: 'Uge',
  five_days: '5 dage',
  all_day: 'Hele dagen',
  all_day_short: 'Heldag',
  events: 'Begivenheder',
  holiday: 'Ferie/fri',
  vacation_registration: 'Ferieanmodning',
  other_events: 'Andet',
  parental_meeting: 'Forældresamtale',
  performance_meeting: 'MUS-samtale',
  school_home_meeting: 'Skole-hjem-samtale',
  excursion: 'Ekskursion',
  birthday: 'Fødselsdag',
  lesson: 'Skema',
  selected_locations: 'Valgte lokaler',
  selected_resources: 'Valgte ressourcer',
  resources: 'Ressourcer',
  no_events: 'Ingen begivenheder',
  accepted: 'Deltag',
  tentative: 'Måske',
  declined: 'Afvis',
  update_answer: 'Opdater svar',
  private_event: 'Privat begivenhed',
  available_seats: 'ledig plads | ledige pladser',
  available_timeslots: 'ledig tid | ledige tider',
  response_accepted: 'Du har accepteret begivenheden',
  response_declined: 'Du har afvist begivenheden',
  response_tentative: 'Du har besvaret begivenheden',
  response_changed: 'Svar opdateret',
  response_deadline: 'Deadline for svar: {date}',
  note_to_class: 'Note til klasse',
  note_to_teacher: 'Note til lærer',
  note_to_substitute: 'Note til vikar',
  lesson_teacher: 'Underviser',
  lesson_assistance: 'Hjælpelærer',
  lesson_substitute: 'Vikar',
  lesson_pedagogue: 'Pædagog',
  primary_location: 'Primær lokale',
  locations: 'Lokaler',
  meeting_place: 'Mødested (fritekst)',
  change_timeslot: 'Skift tidspunkt',
  decline_meeting: 'Afslå samtale for mit barn',
  original_time: 'Original tid',
  new_time: 'Ny tid',
  substitute_teacher: 'Vikar'
};
